module.exports = __webpack_public_path__ + "static/media/CORNER.491733be.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CORNER.png
// module id = 248
// module chunks = 0